import React from 'react';
import PropTypes from 'prop-types';

import style from './page-layout.module.less';

const GridWithPaging = ({ children = null }) => <div className={style['grid-with-paging']}>{children}</div>;

GridWithPaging.propTypes = {
  children: PropTypes.node,
};

export default GridWithPaging;
